(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-recipient')) {
    customElements.define('gift-card-recipient', class GiftCardRecipient extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        var id = this.dataset.sectionId;
        var q = function (s) { return document.getElementById(s + '-' + id); };
        this.toggle = q('gc-checkbox');
        this.fields = q('gc-fields');
        this.control = q('gc-control');
        this.offset = q('gc-offset');
        this.live = q('gc-live');
        this.summary = q('gc-errors');
        this.from = q('gc-from');
        this.rname = q('gc-name');
        this.email = q('gc-email');
        this.message = q('gc-message');
        this.sendOn = q('gc-send-on');
        this.agree = q('gc-agree');
        this.form = this.closest('form');
        this.errMap = new Map([
          [this.from, q('gc-from-error')], [this.rname, q('gc-name-error')], [this.email, q('gc-email-error')],
          [this.message, q('gc-message-error')], [this.sendOn, q('gc-send-on-error')], [this.agree, q('gc-agree-error')]
        ]);
        var self = this;

        if (this.sendOn) {
          var pad = function (n) { return (n < 10 ? '0' : '') + n; };
          var fmt = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
          var today = new Date();
          var max = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90);
          this.sendOn.min = fmt(today);
          this.sendOn.max = fmt(max);
        }
        if (this.offset) this.offset.value = String(new Date().getTimezoneOffset());
        if (this.control) this.control.disabled = true;

        if (this.toggle) {
          this.toggle.addEventListener('change', function () { self.sync(true); });
          this.sync(false);
        }
        if (this.message) {
          this.message.addEventListener('input', function () { self.count(); });
          this.count();
        }
        [this.from, this.rname, this.email, this.message, this.sendOn, this.agree].forEach(function (el) {
          if (el) el.addEventListener('input', function () { self.clearError(el); });
          if (el) el.addEventListener('change', function () { self.clearError(el); });
        });
        if (this.form) this.form.addEventListener('submit', function (e) { self.validate(e); }, true);
      }

      gifting() { return !!(this.toggle && this.toggle.checked); }

      giftFields() { return [this.from, this.rname, this.email, this.message, this.sendOn]; }

      sync(announce) {
        var on = this.gifting();
        this.fields.hidden = !on;
        this.giftFields().concat([this.offset]).forEach(function (el) { if (el) el.disabled = !on; });
        if (!on) {
          this.giftFields().forEach(function (el) { if (el) { el.value = ''; } });
          this.clearAll();
          this.count();
        }
        if (announce && this.live) this.live.textContent = on ? 'Gift card recipient fields expanded.' : 'Gift card recipient fields collapsed.';
      }

      count() {
        var n = this.querySelector('[data-gc-count]');
        if (n && this.message) n.textContent = this.message.value.length;
      }

      errorEl(el) { return this.errMap ? this.errMap.get(el) || null : null; }

      baseDesc(el) {
        var id = this.dataset.sectionId;
        if (el === this.message) return 'gc-message-count-' + id;
        if (el === this.sendOn) return 'gc-send-on-help-' + id;
        return '';
      }

      setError(el, text) {
        var err = this.errorEl(el);
        if (!err) return;
        err.textContent = text;
        err.hidden = false;
        el.setAttribute('aria-invalid', 'true');
        el.setAttribute('aria-describedby', (this.baseDesc(el) + ' ' + err.id).trim());
      }

      clearError(el) {
        var err = this.errorEl(el);
        if (err) { err.hidden = true; err.textContent = ''; }
        el.removeAttribute('aria-invalid');
        var base = this.baseDesc(el);
        if (base) el.setAttribute('aria-describedby', base); else el.removeAttribute('aria-describedby');
      }

      clearAll() {
        var self = this;
        this.giftFields().concat([this.agree]).forEach(function (el) { if (el) self.clearError(el); });
        if (this.summary) { this.summary.hidden = true; }
      }

      validate(e) {
        var self = this;
        var bad = [];
        var check = function (el, ok, text) { if (!ok) { self.setError(el, text); bad.push(el); } else { self.clearError(el); } };
        if (this.gifting()) {
          check(this.from, this.from.value.trim() !== '', 'Enter your name.');
          check(this.rname, this.rname.value.trim() !== '', 'Enter the recipient\'s name.');
          var em = this.email.value.trim();
          check(this.email, em !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em), em === '' ? 'Enter the recipient\'s email.' : 'Enter a valid email address.');
          check(this.message, this.message.value.length <= 200, 'The message can be up to 200 characters.');
          if (this.sendOn.value) {
            var v = this.sendOn.value;
            check(this.sendOn, (!this.sendOn.min || v >= this.sendOn.min) && (!this.sendOn.max || v <= this.sendOn.max), 'Choose a date from today up to 90 days away.');
          }
        }
        check(this.agree, this.agree.checked, 'Please confirm that eGift cards are nonrefundable.');
        if (bad.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (this.live) this.live.textContent = bad.length === 1 ? 'There is 1 error. ' + this.errorEl(bad[0]).textContent : 'There are ' + bad.length + ' errors. Fix them and add to cart again.';
          bad[0].focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
